var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isVisible)?_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":"circle","size":"xs"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }